import React, { Component } from 'react';
import '../assets/teachers.css';
import logo from '../assets/images/logo_avenuepm.png';
import REST from "./REST";
import {selectSchool, userLogout} from "../TeachersComponent/actions";
import {connect} from "react-redux";
import { withRouter } from 'react-router-dom';
import DropDownNotifications from "./DropDownNotifications";
import ReportBugForm from "../ModalFormComponents/ReportBugForm";
import Select from 'react-select';

import logo_maze from '../assets/images/logo_maze.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsign.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import Creatable from "../RequestAccountComponent/RequestAccount";

let appIcon = "";

let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;
let KidspeakInstruction = null;

const getValue = (opts, val) => opts.find(o => o.value === val);

const Header = class HeaderComponent extends Component {

    constructor(props){
        super(props);
        this.state = {
            schoolOptions: [],
            schoolValue: ''
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.handleResources = this.handleResources.bind(this);
        this.handleStudents = this.handleStudents.bind(this);
        this.handleSchoolAdmins = this.handleSchoolAdmins.bind(this);
        this.handleSchools = this.handleSchools.bind(this);
    }

    async componentDidMount() {
        if (this && this.props && this.props.schoolAdmin) {
            await REST.listAdminSchools(this.props.schoolAdmin.id).then(async(response) => {
                if (response.success) {
                    let data = response.body;
                    let schools = [];
                    for (let school of data) {
                        schools.push({value: school.id, label: school.name, samplingStrategyId: school.samplingStrategyId});
                    }
                    await this.setState({schoolOptions: schools});
                    await this.props.schoolLoaded(schools);
                    if(this.props.lastSchool){
                        await this.setState({schoolValue:this.props.lastSchool});
                        this.props.changeSchool(this.props.lastSchool);
                    } else if(schools){
                        await this.setState({schoolValue:schools[0].value});
                        this.props.changeSchool(schools[0].value);
                    }else{
                        await this.setState({schoolValue:-1}); // default: No School
                    }
                } else {
                    console.log('Error', response.msg);
                }
            }, (error) => {
                console.log('Error', error.msg);
            });
        }
    }

    handleSchoolChange = async(newValue) => {
        await this.setState({ schoolValue: newValue.value});
        await this.props.selectSchool(newValue.value);
        console.log('school select:' + this.props.lastSchool);
        this.props.changeSchool(newValue.value);
    };

    handleResources(event){
        this.props.history.push("/resources");
    }

    handleStudents(event){
        this.props.history.push("/teacher");
    }

    handleSchools(event) {
        this.props.history.push("/schools");
    }

    handleSchoolAdmins(event) {
        this.props.history.push("/admin");
    }

    handleLogout = async () => {
        await REST.logout().then(async (response) => {
            if (response.success) {
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                await this.props.persistor.purge();
                await this.props.userLogout();
                this.props.history.push("/");
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    };

    render() {
        let PNModel;
        if(this.props.appName === 'Picture Naming'){
            appIcon = logo_picturenaming;
            if(this.props.PNModel === "computer"){
                PNModel = "(Computer Tasks)";
            }else if (this.props.PNModel === "manual"){
                PNModel = "(Picture Cards)";
            }else{
                PNModel = "(1-1 Computer Tasks)";
            }
        }
        if(this.props.appName === 'CopyRight'){
            appIcon = logo_copyright;
        }
        if(this.props.appName === 'Word Sign/Say'){
            appIcon = logo_wordsignsay;
        }
        if(this.props.appName === 'Slash'){
            appIcon = logo_slashtest;
        }
        if(this.props.appName === 'KidSpeak'){
            appIcon = logo_kidspeak;
        }
        if(this.props.appName === 'Maze'){
            appIcon = logo_maze;
        }
        if(this.props.appName === 'KidSign'){
            appIcon = logo_kidsign;
        }
        if(this.props.appName === 'WordMark'){
            appIcon = logo_wordmark;
        }
        return (
            <nav id="header" className="navbar">
                <div id="header-container" className="container navbar-container">
                    <div className="navbar-header fl">
                        <a id="brand" className="navbar-brand" href="/">
                            <img src={logo} alt="AvenuePM" border="0" style={{marginTop: -15}}/>
                        </a>
                    </div>
                    {
                        this.props.schoolAdminManagement||this.props.schoolManagement ?
                            <div className={"navbar col-md-6"}>
                                <div id="navbar" className="navbar fr" onClick={this.handleSchoolAdmins} style={{marginTop:15}}>
                                    <a className={this.props.schoolAdminManagement?"handBtn active":"handBtn "}>
                                        <span>School Admins</span>
                                    </a>
                                </div>
                                <div id="navbar" className="navbar fr" onClick={this.handleSchools} style={{marginTop:15}}>
                                    <a className={this.props.schoolManagement?"handBtn active":"handBtn "}>
                                        <span>Schools</span>
                                    </a>
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        this.props.schoolAdmin?
                            <div className={"navbar col-md-6"}>
                                <div className={"row"}>
                                    <div className={"col-md-5"} style={{marginTop:15, width:150}}>
                                        <h1 style={{marginLeft:50}}>
                                            School:
                                        </h1>
                                    </div>
                                    <div className={"col-md-7"} style={{marginTop:15, width:250}}>
                                        <Select
                                            onChange={this.handleSchoolChange}
                                            options={this.state.schoolOptions}
                                            placeholder = {"Select a school..."}
                                            value={getValue(this.state.schoolOptions, this.state.schoolValue)}
                                        />
                                    </div>
                                </div>
                            </div>:null

                    }
                    <div id="navbar" className="navbar fr" style={{marginTop:15}} onClick={this.props.logout ? this.props.logout : this.handleLogout}>
                        <a className="handBtn">
                            <span>Logout</span>
                        </a>
                    </div>
                    {this.props.bugReport ?
                        <ReportBugForm {...this.props}/>
                        :null
                    }

                    {this.props.resources || this.props.students ?
                        <div>
                            <div id="navbar" className="navbar fr" style={{marginTop:15}} onClick={this.handleResources}>
                                <a className={this.props.resources?"handBtn active":"handBtn "}>
                                    <span>Resources</span>
                                </a>
                            </div>
                            <div id="navbar" className="navbar fr" style={{marginTop:15}} onClick={this.handleStudents}>
                                <a className={this.props.students?"handBtn active":"handBtn "}>
                                    <span>Students</span>
                                </a>
                            </div>
                        </div>
                        :null
                    }
                </div>
            </nav>
        )
    }
};

const bindActionToProps = dispatch => {
    return {
        selectSchool: async(selectedSchool) => await dispatch(selectSchool(selectedSchool)),
        userLogout: async() => await dispatch(userLogout())
    };
};

const mapStateToProps = state => ({
    lastSchool: state.teacherReducer.lastSchool
});

export default withRouter(connect(mapStateToProps,bindActionToProps)(Header));
